
import { Vector as layerVector } from 'ol/layer';
import { Group as layerGroup } from 'ol/layer';
import { Snap } from 'ol/interaction';

  /*
    The snap interaction must be added after the Modify and Draw interactions
    in order for its map browser event handlers to be fired first. Its handlers
    are responsible of doing the snapping.
    I have a snap example on x1 in htdocs/ol-snap/
  */

export default function(map) {

  let interactions = [];

  // switchboard
  return function(mode) {

    switch(mode) {
      case 'on':
        map.getLayers().forEach((layer) => {
          /*
          if (layer instanceof layerGroup) console.log (layer.get('title'),'layerGroup')
          else if (layer instanceof layerVector) console.log (layer.get('title'),'layerVector')
          else console.log (layer.get('title'),'other')
          */
          if (layer instanceof layerVector) {
            let interaction = new Snap({
              source: layer.getSource()
            });
            interactions.push(interaction);
          }
        });

        for(let snap of interactions ) {
          map.addInteraction(snap);
        }
        break;
      case 'off':
        for(let snap of interactions ) {
          map.removeInteraction(snap);
        }
        interactions.length = 0
        break;
    }
    // console.log('snap', mode, interactions.length)
  }
}
